// removed by extract-text-webpack-plugin
module.exports = {"slideStage":"slideStage--o-Zg4","hitBox":"hitBox--3LRWx","arrowWrapper":"arrowWrapper--1b670","right":"right--3co85","left":"left--ussJi","pagination":"pagination--39i5y","dot":"dot--3oHkC","active":"active--2el4G"};


/*****************
 ** WEBPACK FOOTER
 ** ./shared-components/FadeCarouselSide/index.scss
 ** module id = 1485
 ** module chunks = 17
 **/